// frontend/packages/business-console/src/components/build-interview/BuildInterviewAnimations.jsx
//
// Global keyframes for the build-interview redesign (Website Builder Redesign,
// Phase 1), injected once by the page. Three animations give the flow its
// "alive" feel; all are disabled under prefers-reduced-motion.
//   - bi-shimmer:  skeleton cards during build (AssemblyPreview)
//   - bi-softpulse: pulsing status dots (current build stage, active brief)
//   - bi-ringpulse: expanding ring on the current journey-rail / build stage

import React from 'react';
import { GlobalStyles } from '@mui/material';

export default function BuildInterviewAnimations() {
  return (
    <GlobalStyles
      styles={{
        '@keyframes bi-shimmer': {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(100%)' },
        },
        '@keyframes bi-softpulse': {
          '0%, 100%': { opacity: 1, transform: 'scale(1)' },
          '50%': { opacity: 0.55, transform: 'scale(0.85)' },
        },
        '@keyframes bi-ringpulse': {
          '0%': { boxShadow: '0 0 0 0 rgba(37,99,235,.35)' },
          '100%': { boxShadow: '0 0 0 7px rgba(37,99,235,0)' },
        },
        '@media (prefers-reduced-motion: reduce)': {
          '[data-bi-anim], [data-bi-anim]::after, [data-bi-anim]::before': {
            animation: 'none !important',
          },
        },
      }}
    />
  );
}
